import { styled } from '@components-shared/src/stitches';

export const Subheader = styled('div', {
  base: 'L',
  fontWeight: '500',
  color: '$neutral400',
  paddingLeft: 24,
  marginTop: 8,

  '@laptop': {
    paddingLeft: 0,
  },
});

export const ActivityFeed = styled('div', {
  paddingX: 24,
  overflow: 'hidden',
  marginTop: 8,

  '@tablet': {
    marginTop: 32,
  },

  '@laptop': {
    paddingX: 0,
  },
});
